function createRef(input) {
    const cb = (e) => {
        cb.ref = cb.current = e;
        if (typeof input === "function") {
            const inputResult = input();
            if (typeof inputResult === "function") {
                inputResult(e);
            }
        }
        else if (typeof input?.ref === "function") {
            input.ref(e);
        }
    };
    return cb;
}
export default createRef;
